import { ProcessedBetSlipData, BetSlip } from '../../../backend/src/models/BetSlip';

export type BetSlipStatus = 'pending' | 'won' | 'lost' | 'push' | 'cancelled';

export interface ExportFilters {
  startDate?: Date;
  endDate?: Date;
  casino?: string;
  status?: BetSlipStatus;
  betType?: BetType;
}

export interface ColumnConfig {
  header: string;
  key: string;
  selected: boolean;
}

export interface ExportColumns {
  betSlips: ColumnConfig[];
  selections: ColumnConfig[];
}

export interface ExportRequest {
  filters?: ExportFilters;
  selectedColumns?: {
    betSlips: string[];
    selections: string[];
  };
}
export type BetType = 'straight' | 'parlay' | 'teaser' | 'round_robin' | 'futures' | 'prop';
export type MarketType = 'money_line' | 'point_spread' | 'total' | 'prop' | 'futures';

export interface BetSlipSelection {
  sport?: string;
  league?: string;
  eventDateTime?: Date;
  homeTeam?: string;
  awayTeam?: string;
  selectedTeam?: string;
  marketType?: MarketType;
  line?: number;
  odds?: string;
}

export interface BetSlipWithSelections extends Omit<BetSlip, 'selections'> {
  imageUrl: string;
  extractedText: string;
  selections: BetSlipSelection[];
}

// Extend ProcessedBetSlipData to include additional fields from API response
interface ExtendedProcessedBetSlipData extends ProcessedBetSlipData {
  id?: number;
  status?: BetSlipStatus;
  notes?: string;
}

// Override the imported UpdateBetSlipDTO to match what the backend actually accepts
declare module '../../../backend/src/models/BetSlip' {
  interface UpdateBetSlipDTO {
    ticketId?: string;
    casinoName?: string;
    eventDateTime?: Date;
    wagerAmount?: number;
    potentialPayout?: number;
    betType?: BetType;
    status?: BetSlipStatus;
    settledDateTime?: Date;
    notes?: string;
    selections?: UpdateBetSelectionDTO[];
  }
}

export function convertToBetSlipWithSelections(data: ExtendedProcessedBetSlipData): Partial<BetSlipWithSelections> {
  return {
    id: data.id,
    imageUrl: data.imageUrl,
    extractedText: data.extractedText,
    ticketId: data.ticketId,
    casinoName: data.casinoName,
    eventDateTime: data.eventDateTime,
    wagerAmount: data.wagerAmount,
    potentialPayout: data.potentialPayout,
    betType: data.betType,
    barcodeData: data.barcodeData,
    windowNumber: data.windowNumber,
    selections: data.selections || [],
    ocrConfidence: data.ocrConfidence,
    status: data.status,
    notes: data.notes
  };
}

export function mapBetSlipData(data: ExtendedProcessedBetSlipData[]): Partial<BetSlipWithSelections>[] {
  return data.map(convertToBetSlipWithSelections);
}